import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { userInfo } from 'os';
import { HouseUser } from '../../profile.model';
import { ProfileService } from '../../profile.service';
import { SessionStateService } from '../../../../core/services/session-state.service';

@Component({
  selector: 'app-new-user-permissions',
  templateUrl: './new-user-permissions.component.html',
  styleUrls: ['./new-user-permissions.component.scss']
})
export class NewUserPermissionsComponent implements OnInit {

  @Input() errorMessage: string;

  @Input() houseUser: HouseUser;

  @Output() emitHouseUser: EventEmitter<HouseUser> = new EventEmitter<HouseUser>();

  constructor(private profileService: ProfileService,
              private sessionStateService: SessionStateService) {
   }

  ngOnInit() {
  }

  onEmit(houseUser?: HouseUser) {
    this.emitHouseUser.emit(houseUser);
  }

  onBack() {
    this.emitHouseUser.emit();
  }

  onAddUser() {
    this.emitHouseUser.emit(this.houseUser);
  }

  isPermissionRoleAdmin(): boolean {
    return this.houseUser.permissionRole === 'Admin';
  }

  isReceiveReport(): boolean {
    return this.houseUser.receiveReport;
  }

  receiveNotification(): boolean {
    return this.houseUser.receivePush;
  }

  getHouseName() {
    return this.sessionStateService.getHouse().name;
  }

  changePermissionRole() {
    if (this.houseUser.permissionRole === 'Admin') {
      this.houseUser.permissionRole = 'User';
    } else if (this.houseUser.permissionRole === 'User') {
      this.houseUser.permissionRole = 'Admin';
    }
  }

  changeReceiveReport() {
    this.houseUser.receiveReport = !this.houseUser.receiveReport;
  }

  changeNotify() {
    this.houseUser.receivePush = !this.houseUser.receivePush;
  }
  receiveEmail(): boolean {
    return this.houseUser.receiveEmail;
  }

  changeEmail() {
    this.houseUser.receiveEmail = !this.houseUser.receiveEmail;
  }


}



// WEBPACK FOOTER //
// ./src/app/entities/profile/new-user-dialog/new-user-permissions/new-user-permissions.component.ts